module.exports = __webpack_public_path__ + "img/item-4.e1cedee.png";